import ConfirmActionPopup from 'components/ConfirmActionPopup';
import StyledActionButton from 'components/layout/StyledActionButton';
import React, { Component } from 'react';
import { Popup } from 'semantic-ui-react';

const PopupStyle = {
  borderRadius: 5,
  opacity: 0.7,
  padding: '7px'
};

interface Props {
  disabled?: boolean,
  popupMessage?: string,
  hoverMessage?: string,
  popupPosition?:
      | 'top left'
      | 'top right'
      | 'bottom right'
      | 'bottom left'
      | 'right center'
      | 'left center'
      | 'top center'
      | 'bottom center',
  trigger: React.ReactNode,
  onConfirm: () => void
}

interface State {

}

class ConfirmActionButton extends Component<Props, State> {

  render(): React.ReactNode {
    const {
      disabled = false, hoverMessage, popupMessage, popupPosition = "top center", onConfirm, trigger
    } = this.props;

    if (popupMessage) {
      return (
          <ConfirmActionPopup
              message={popupMessage}
              position={popupPosition}
              renderTarget={trigger ? trigger : this.renderButton()}
              onConfirmAction={onConfirm}
              disabled={disabled}
          />
      );
    }
    return (
        <StyledActionButton icon
                            disabled={disabled}
                            type='button'
                            onClick={onConfirm}
        >
          <Popup
              trigger={trigger}
              content={hoverMessage}
              size='small'
              position={popupPosition}
              style={PopupStyle}
              inverted
          />
        </StyledActionButton>
    );

  }

  renderButton = (): React.ReactNode => {
    const {disabled = false, hoverMessage, trigger} = this.props;

    return (
        <StyledActionButton icon
                            disabled={disabled}
                            type='button'
        >
          <Popup
              trigger={trigger}
              content={hoverMessage}
              size='small'
              position='top center'
              style={PopupStyle}
              inverted
          />
        </StyledActionButton>
    );
  };

}

export default ConfirmActionButton;
